module.exports = __webpack_public_path__ + "static/media/01C.dcf8625e.png";